(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-lumino-related-slider]').forEach((root) => {
      if (root.dataset.relatedReady) return;
      root.dataset.relatedReady = 'true';
      const track = root.querySelector('[data-related-track]');
      const controls = root.querySelector('[data-related-controls]');
      const previous = root.querySelector('[data-related-prev]');
      const next = root.querySelector('[data-related-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const rtl = getComputedStyle(track).direction === 'rtl';
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        controls.hidden = maximum <= 2;
        previous.disabled = position <= 2;
        next.disabled = position >= maximum - 2;
      };
      const step = () => {
        const slide = track.querySelector('.lumino-related-articles__slide');
        return slide.getBoundingClientRect().width + (Number.parseFloat(getComputedStyle(track).columnGap) || 0);
      };
      const move = (direction) => {
        track.scrollBy({
          left: direction * step() * (rtl ? -1 : 1),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          track.scrollTo({
            left: event.key === 'Home' ? 0 : (track.scrollWidth - track.clientWidth) * (rtl ? -1 : 1),
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
        }
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
